(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/andra-chansen/assets/javascripts/utils.js') >= 0) return;  svs.modules.push('/components/numbergames/andra-chansen/assets/javascripts/utils.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
const {
  productMapping
} = svs.numbergames;
const {
  CONSTANTS
} = svs.numbergames.andra_chansen;
const isInPeriod = (lottoDrawNumber, startDrawNumber, endDrawNumber) => lottoDrawNumber >= startDrawNumber && lottoDrawNumber <= endDrawNumber;
const isBeforeJune20 = date => new Date(date).getTime() < Date.parse('2020-06-20');

const andraChansenDraw = () => svs.numbergames.andra_chansen.data.andraChansenDraw;

const afterDromvinstenDraw = () => svs.numbergames.andra_chansen.data.afterDromvinstenDraw;

const isAndraChansen = draw => (draw === null || draw === void 0 ? void 0 : draw.drawTypeId) === CONSTANTS.DRAW_TYPE.ANDRA_CHANSEN;

const isAfterDromvinsten = draw => (draw === null || draw === void 0 ? void 0 : draw.drawTypeId) === CONSTANTS.DRAW_TYPE.AFTER_DROMVINSTEN;

const startAndEndDraws = (draw, productId) => {
  var _draw$products;
  return draw === null || draw === void 0 ? void 0 : (_draw$products = draw.products) === null || _draw$products === void 0 ? void 0 : _draw$products.find(product => productMapping.isSameProduct(product.productId, productId));
};

const triggeredAfterDromvinsten = lottoDraw => {
  if (!lottoDraw.hasDromvinsten) return false;
  const draw = afterDromvinstenDraw();
  if (draw) {
    const drawNumbers = startAndEndDraws(draw, lottoDraw.productId);
    return lottoDraw.drawNumber === (drawNumbers === null || drawNumbers === void 0 ? void 0 : drawNumbers.startDrawNumber) - 1;
  }
};

const showBannerDateSmartness = draw => {
  if (draw) {
    const dayDifferance = dateFns.differenceInDays(new Date(draw.endDate), new Date());
    return dayDifferance < 22 || Boolean(afterDromvinstenDraw());
  }
};

const isInCurrentPeriod = (draw, lottoDraw) => {
  if (draw) {
    const drawNumbers = startAndEndDraws(draw, lottoDraw.productId);
    if (drawNumbers) {
      const {
        startDrawNumber,
        endDrawNumber
      } = drawNumbers;
      return isInPeriod(lottoDraw.drawNumber, startDrawNumber, endDrawNumber);
    }
  }
  return false;
};

const givesChances = _ref => {
  let {
    hasJoker,
    isSyndicate,
    isFraction,
    drawDate
  } = _ref;
  if (isSyndicate || isFraction) {
    if (drawDate && isBeforeJune20(drawDate)) {
      return false;
    }
  }
  return hasJoker;
};

const chancesPerLottoDraw = wager => givesChances(wager) ? wager.rowCount * (wager.hasLotto2 + 1) : 0;

const chancesPerWager = wager => {
  const chancesPerDraw = chancesPerLottoDraw(wager);
  const chancesPerWeek = chancesPerDraw * wager.numberOfDays;
  if (wager.isSubscription) return chancesPerWeek;
  return chancesPerWeek * wager.drawCount;
};

const afterDromvinstenChances = (lottoDraws, wager, includeSubscription) => {
  const draw = afterDromvinstenDraw();
  let numberOfDraws = 0;
  if (draw && (!wager.isSubscription || includeSubscription)) {
    lottoDraws.forEach(_ref2 => {
      let {
        productId,
        drawNumber
      } = _ref2;
      const drawNumbers = startAndEndDraws(draw, productId);
      if (drawNumbers) {
        const {
          startDrawNumber,
          endDrawNumber
        } = drawNumbers;
        for (let i = 0; i < wager.drawCount; i++) {
          if (isInPeriod(drawNumber + i, startDrawNumber, endDrawNumber)) numberOfDraws++;
        }
      }
    });
  }
  return chancesPerLottoDraw(wager) * numberOfDraws;
};

const chancesPerDrawType = (lottoDraws, wager) => {
  const draws = [];
  const chancesAndraChansen = chancesPerWager(_objectSpread(_objectSpread({}, wager), {}, {
    numberOfDays: lottoDraws.length,
    isSubscription: false
  }));
  if (chancesAndraChansen) draws.push({
    chances: chancesAndraChansen,
    isAfterDromvinsten: false
  });
  const chancesAfterDromvinsten = afterDromvinstenChances(lottoDraws, wager);
  if (chancesAfterDromvinsten) draws.push({
    chances: chancesAfterDromvinsten,
    isAfterDromvinsten: true
  });
  return draws;
};
svs.numbergames.andra_chansen.utils = {
  andraChansenDraw,
  afterDromvinstenDraw,
  isAndraChansen,
  isAfterDromvinsten,
  startAndEndDraws,
  triggeredAfterDromvinsten,
  showBannerDateSmartness,
  isInCurrentPeriod,
  givesChances,
  chancesPerLottoDraw,
  chancesPerWager,
  afterDromvinstenChances,
  chancesPerDrawType
};

 })(window);